export function formatRupiah(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = typeof value === "string" ? Number(value.replace(/[^0-9-]/g, "")) : Number(value);
  if (Number.isNaN(n)) return "—";
  return "Rp " + n.toLocaleString("id-ID");
}

export function parseRupiah(str) {
  if (str === null || str === undefined || str === "") return null;
  const n = Number(String(str).replace(/[^0-9-]/g, ""));
  return Number.isNaN(n) ? null : n;
}

export function formatDateTimeJakarta(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return new Intl.DateTimeFormat("id-ID", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta",
    }).format(d) + " WIB";
  } catch {
    return iso;
  }
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
    return new Intl.DateTimeFormat("id-ID", {
      day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Jakarta",
    }).format(d);
  } catch {
    return iso;
  }
}

export const STATUS_META = {
  pending_review: { label: "Menunggu Pemeriksaan", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  draft: { label: "Draf", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  approved: { label: "Disetujui", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  rejected: { label: "Ditolak", cls: "bg-red-100 text-red-800 border-red-300" },
};

export const OCR_META = {
  queued: { label: "Antre dibaca AI", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  processing: { label: "Sedang dibaca AI…", cls: "bg-blue-100 text-blue-700 border-blue-300" },
  done: { label: "Selesai dibaca", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  failed: { label: "Gagal dibaca", cls: "bg-red-100 text-red-700 border-red-300" },
  limited: { label: "Layanan AI penuh", cls: "bg-orange-100 text-orange-700 border-orange-300" },
};
